import type { Component } from 'vue';

import CellActions from './CellActions.vue';
import CellDate from './CellDate.vue';
import CellDatetime from './CellDatetime.vue';
import CellRelation from './CellRelation.vue';

const renderers: Record<string, Component> = {};

/**
 * Register a cell renderer. Modules call this from their `index.ts` setup hook
 * to add display logic without touching the shared table.
 */
export function registerCellRenderer(name: string, component: Component): void {
    renderers[name] = component;
}

/**
 * Resolve a renderer by name. Unknown or missing names fall through to the
 * legacy cell path, so a stale column definition degrades instead of breaking.
 */
export function resolveCellRenderer(name?: string | null): Component | null {
    if (!name) {
        return null;
    }

    return renderers[name] ?? null;
}

registerCellRenderer('date', CellDate);
registerCellRenderer('datetime', CellDatetime);
registerCellRenderer('relation', CellRelation);
registerCellRenderer('actions', CellActions);
